class BackInStock extends HTMLElement {
  constructor() {
    super()

    const validateEmail = (email) => {
      return String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
    }

    const element = this
    const variantInput = element.querySelector('input[name="variant"]')
    const emailInput = element.querySelector('input[type="email"]')
    const button = element.querySelector('button')

    button.addEventListener('click', (event) => {
      event.preventDefault()

      // Reset error class
      emailInput.classList.remove('js-error')
      // Also remove if type alter the input because they are to dumb to fucking type a correct email address
      emailInput.addEventListener('input', () => {
        emailInput.classList.remove('js-error')
      })

      const email = emailInput.value
      if (email) {
        // Validate email or show error
        if (!validateEmail(email)) {
          emailInput.classList.add('js-error')
        }

        // Check if multiple variants are selected
        const variants = variantInput.value.split(',')

        variants.forEach((variant) => {
          fetch('https://a.klaviyo.com/onsite/components/back-in-stock/subscribe', {
            headers: {
              accept: 'application/json, text/plain, */*',
              'content-type': 'application/x-www-form-urlencoded;charset=UTF-8',
            },
            body: new URLSearchParams({
              a: 'U8u8Vd',
              email: email,
              platform: 'shopify',
              variant: parseFloat(variant),
            }),
            method: 'POST',
          })
            .then((response) => {
              // Success
              if (response.status === 200) {
                button.disabled = true
                emailInput.classList.add('js-success')
                emailInput.value = null
                emailInput.disabled = true
                emailInput.placeholder = "You're on the list!"
              }
            })
            .catch((err) => {
              console.error(err)
            })
        })
      } else {
        emailInput.classList.add('js-error')
      }
    })
  }
}

// Check if element is defined, if not define it..
// eslint-disable-next-line no-undefined
if (customElements.get('back-in-stock') === undefined) {
  customElements.define('back-in-stock', BackInStock)
}
